import {
    GET_APPLIED_CASHPASS,
    APPLY_CASHPASS,
    REMOVE_CASHPASS,
    CLEAR_CASHPASS_ERROR,
    SET_CASHPASS_LOADING,
} from '../actionTypes/CashpassCartActionTypes';

/**
 * Fetch the rewards currently applied to the cart (source of truth for applied
 * state and the adjustment id needed for removal).
 */
export const getAppliedCashpass = () => ({
    type: GET_APPLIED_CASHPASS,
});

/**
 * Apply a cashpass certificate to the cart.
 * @param {Object} certificate - certificate to apply; needs code + serialNumber.
 * The saga strips the "-" from the code before POSTing.
 */
export const applyCashpass = (certificate) => ({
    type: APPLY_CASHPASS,
    payload: certificate,
});

/**
 * Remove a cashpass from the cart by its applied adjustment id.
 * @param {Object} args
 * @param {string} args.id - adjustment id (from the applied-rewards GET).
 * @param {string} [args.serialNumber] - kept so the reducer can reconcile the card.
 */
export const removeCashpass = ({ id, serialNumber }) => ({
    type: REMOVE_CASHPASS,
    payload: { id, serialNumber },
});

/**
 * Clear a captured apply/remove error for a specific cashpass (by serialNumber),
 * or all errors when no serialNumber is provided.
 * @param {string} [serialNumber]
 */
export const clearCashpassError = (serialNumber) => ({
    type: CLEAR_CASHPASS_ERROR,
    payload: { serialNumber },
});

/**
 * Toggle the cashpass loader. Dispatched by the saga around apply/remove/get
 * API calls so the UI can show a loader while a request is in flight.
 * @param {boolean} loading
 */
export const setCashpassLoading = (loading) => ({
    type: SET_CASHPASS_LOADING,
    payload: { loading },
});

export default {
    getAppliedCashpass,
    applyCashpass,
    removeCashpass,
    clearCashpassError,
    setCashpassLoading,
};
